import axiosPrivate from "../../../api/axiosPrivate";
import {
  CREATE_WORKFLOW,
  GET_ALL_WORKFLOWS,
  GET_SINGLE_WORKFLOWS,
  UPDATE_SINGLE_WORKFLOW,
} from "../../../api/constant";

const submitWorkflow = async (data) => {
  const response = await axiosPrivate.post(`${CREATE_WORKFLOW}`, data);
  return response.data;
};
const getAllWorkflow = async () => {
  const response = await axiosPrivate.get(`${GET_ALL_WORKFLOWS}`);
  return response.data;
};
const getSingleWorkflow = async (id) => {
  const response = await axiosPrivate.get(`${GET_SINGLE_WORKFLOWS}/${id}`);
  return response.data;
};
const updateSingleWorkflow = async ({ id, data }) => {
  const response = await axiosPrivate.post(
    `${UPDATE_SINGLE_WORKFLOW}/${id}`,
    data
  );
  return response.data;
};

const workflowService = {
  submitWorkflow,
  getAllWorkflow,
  getSingleWorkflow,
  updateSingleWorkflow,
};

export default workflowService;
